import { defineComponent as _defineComponent } from 'vue'
import SettingsPopup from '@/views/settings/components/utils/SettingsPopup.vue';
import { computed, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXConfirm',
  props: {
  value: {
    type: Boolean
  },
  yesLabel: {
    type: String,
    default: ''
  },
  noLabel: {
    type: String,
    default: ''
  },
  type: {
    type: String as PropType<'default' | 'watchlist' | 'guest-members' | 'contracts'>,
    default: 'default'
  },
  okType: {
    type: String as PropType<'' | 'ok' | 'warning' | 'primary'>,
    default: ''
  },
  width: {
    type: String,
    default: '250px'
  },
  enableConfirm: {
    type: Boolean,
    default: true
  },
  enableClose: {
    type: Boolean,
    default: true
  },
  zIndex: {
    type: Number,
    default: 0,
  },
  justConfirmButton: {
    type: Boolean,
    default: false,
  },
},
  emits: ['input', 'confirm'],
  setup(__props, { emit }) {

const props = __props;





const colorVar = computed(() => {
  switch (props.okType) {
    case 'warning': return 'var(--foreground-color--warning-intense)';
    case 'ok': return 'var(--foreground-color--ok)';
    case 'primary': return 'var(--primary-color)';
  }
  return '';
});

const close = () => {
  emit('input', false);
};

const confirm = (which: boolean) => {
  close();
  emit('confirm', which);
};

return { __sfc: true,props, emit, colorVar, close, confirm, SettingsPopup }
}

})